import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/accessInput/styles.scss';export default {
  "accessInput": "_accessInput_18lxd_1",
  "title": "_title_18lxd_5",
  "group": "_group_18lxd_11",
  "label": "_label_18lxd_19"
};